import React from 'react';
import { ClientsList } from '../../components/admin/ClientsList';
import { useClientsList } from '../../hooks/useClientsList';

export const ClientsListPage: React.FC = () => {
  const clientsListProps = useClientsList();

  return <ClientsList {...clientsListProps} />;
};
